export const permissionsLevelsEnum = {
  FullAccess: "0",
  ReadOnly: "1",
}
